import { BellOutlined, CheckCircleOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { Badge, Button, Empty, Popover, Typography, theme } from "antd";

const { Text } = Typography;

interface Notification {
	id: string;
	title: string;
	description: string;
	type: "info" | "success";
	time: string;
}

const MOCK_NOTIFICATIONS: Notification[] = [];

function NotificationList({ items }: { items: Notification[] }) {
	const { token } = theme.useToken();

	if (items.length === 0) {
		return (
			<div className="flex flex-col items-center justify-center py-6" style={{ width: 320 }}>
				<Empty
					image={Empty.PRESENTED_IMAGE_SIMPLE}
					description={
						<Text type="secondary" style={{ fontSize: 13 }}>
							Yangi bildirishnomalar yo'q
						</Text>
					}
				/>
			</div>
		);
	}

	return (
		<div style={{ width: 320, maxHeight: 400, overflow: "auto" }}>
			{items.map((item) => (
				<div
					key={item.id}
					className="flex gap-3 px-3 py-3"
					style={{ borderBottom: `1px solid ${token.colorBorderSecondary}` }}
				>
					<span
						style={{
							width: 32,
							height: 32,
							borderRadius: 8,
							background:
								item.type === "success" ? `${token.colorSuccess}15` : `${token.colorPrimary}15`,
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							flexShrink: 0,
						}}
					>
						{item.type === "success" ? (
							<CheckCircleOutlined style={{ color: token.colorSuccess, fontSize: 14 }} />
						) : (
							<InfoCircleOutlined style={{ color: token.colorPrimary, fontSize: 14 }} />
						)}
					</span>
					<div className="flex-1 min-w-0">
						<Text strong style={{ fontSize: 13, display: "block" }}>
							{item.title}
						</Text>
						<Text type="secondary" style={{ fontSize: 12 }}>
							{item.description}
						</Text>
						<Text type="secondary" style={{ fontSize: 11, display: "block", marginTop: 2 }}>
							{item.time}
						</Text>
					</div>
				</div>
			))}
		</div>
	);
}

export function NotificationCenter() {
	const notifications = MOCK_NOTIFICATIONS;

	return (
		<Popover
			content={<NotificationList items={notifications} />}
			title={
				<div className="flex items-center justify-between px-1 py-1">
					<Text strong>Bildirishnomalar</Text>
					{notifications.length > 0 && (
						<Button type="link" size="small" style={{ fontSize: 12 }}>
							Barchasini o'qish
						</Button>
					)}
				</div>
			}
			trigger="click"
			placement="bottomRight"
			arrow={false}
		>
			<Badge count={notifications.length} size="small" offset={[-2, 2]}>
				<Button type="text" icon={<BellOutlined style={{ fontSize: 18 }} />} />
			</Badge>
		</Popover>
	);
}
